import { render, staticRenderFns } from "./zlCertification.vue?vue&type=template&id=98a82700&scoped=true&"
import script from "./zlCertification.vue?vue&type=script&lang=js&"
export * from "./zlCertification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98a82700",
  null
  
)

export default component.exports